import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { ValidatorForm } from 'react-material-ui-form-validator';
import VisitaFiliadoVisualizacaoToolbar from './components/VisitaFiliadoVisualizacaoToolbar';
import Paper from '@material-ui/core/Paper';
import VisitaFiliadoVisualizacaoDetalhes from './components/VisitaFiliadoVisualizacaoDetalhes';
import ProgressFullScreen from '../../components/Compartilhados/ProgressFullScreen';
import SnackbarCustom from '../../components/Compartilhados/Snackbar';
import { ServiceValues } from '../../values/ServiceValues';
import { ServiceAxios } from '../../services/ServiceEW';
import { GridList, IconButton, TextField } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { Values } from '../../values/Values';
import { getAllPacotes } from '../../services/PacoteService';
import { getAllInsumos } from '../../services/InsumoService';
import { getAllArmas } from '../../services/ArmaService';
import { getAllModalidades } from '../../services/ModalidadesService';
import moment from 'moment';
import {
  deleteVisitaFiliado,
  getVisitaFiliado,
  postVisitaFiliado,
  putVisitaFiliado
} from '../../services/VisitaFiliadoService';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Alert from '@material-ui/lab/Alert/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle/AlertTitle';
import InputAdornment from '@material-ui/core/InputAdornment';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import { MessageValues } from '../../values/MessageValues';
import { getRelatorioResumoVisitaFiliado } from '../../services/RelatorioService';


const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    marginTop: theme.spacing(1)
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  toolbar: {
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3)
  }
}));



export default function VisitaFiliadoVisualizacao({history}) {
  const classes = useStyles();
  const [visitaFiliado, setVisitaFiliado] = useState(history.location.state.visitaFiliado);
  const [loading, setLoading] = React.useState(false);
  const [showMessageSnack, setShowMessageSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [typeSnack, setTypeSnack] = useState('success');
  const [showDialogConfirmacaoDeleteVisitaFiliado, setShowDialogConfirmacaoDeleteVisitaFiliado] = useState(false);
  const [senha, setSenha] = useState('');
  const [mostrarSenha, setMostrarSenha] = useState(false);

  const [armas, setArmas] = useState({
    result: []
  });
  const [insumos, setInsumos] = useState({
    result: []
  });
  const [pacotes, setPacotes] = useState({
    result: []
  });
  const [modalidades, setModalidades] = useState({
    result: []
  });

  useEffect(() => {
    getModalidades();
    getArmas();
    getInsumos();
    getPacotes();


  }, []);

  async function getPacotes() {
    try{
      setLoading(true);
      let pacotes1 = await getAllPacotes(100, 1);
      if(pacotes1.isSuccess){
        setLoading(false);
        setPacotes(pacotes1);
      }
      else{
        setLoading(false);
        setTypeSnack('warning');
        setMessageSnack(pacotes1.message);
        setShowMessageSnack(true);
      }
    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }

  async function getInsumos() {
    try{
      setLoading(true);
      let insumos1 = await getAllInsumos(1000, 1);
      if(insumos1.isSuccess){
        setLoading(false);
        setInsumos(insumos1);
      }
      else{
        setLoading(false);
        setTypeSnack('warning');
        setMessageSnack(insumos1.message);
        setShowMessageSnack(true);
      }
    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }

  async function getArmas() {
    try{
      setLoading(true);
      let armas1 = await getAllArmas(100, 1);
      if(armas1.isSuccess){
        setLoading(false);
        setArmas(armas1);
      }
      else{
        setLoading(false);
        setTypeSnack('warning');
        setMessageSnack(armas1.message);
        setShowMessageSnack(true);
      }
    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }

  async function getModalidades() {
    try{
      setLoading(true);
      let modalidades1 = await getAllModalidades(100, 1);
      if(modalidades1.isSuccess){
        setLoading(false);
        setModalidades(modalidades1);
      }
      else{
        setLoading(false);
        setTypeSnack('warning');
        setMessageSnack(modalidades1.message);
        setShowMessageSnack(true);
      }
    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }

  function showConfirmationDeleteVisitaFiliado(){
    setShowDialogConfirmacaoDeleteVisitaFiliado(true);

  }

  async function deleteVisita(event) {
    try {
      setShowDialogConfirmacaoDeleteVisitaFiliado(false);
      setLoading(true);
      const auth = JSON.parse(localStorage.getItem('auth'));
      const deleteVisita = await deleteVisitaFiliado(visitaFiliado, senha, auth.result.idUsuario);
      setSenha('');
      setLoading(false);
      if(deleteVisita.isSuccess){
        setTypeSnack('success');
        setMessageSnack(deleteVisita.message);
        setShowMessageSnack(true);
        history.push('/visita-filiado-list')
      }
      else{
        setTypeSnack('error');
        setMessageSnack(deleteVisita.message);
        setShowMessageSnack(true);
      }
    }
    catch (e) {
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }

  function onCancelDeleteVisitaFiliado() {
    setShowDialogConfirmacaoDeleteVisitaFiliado(false)
  }

  async function downloadPDF() {
    try{
      setLoading(true);
      const relatorio = await getRelatorioResumoVisitaFiliado(visitaFiliado.idVisitaFiliado);
      if(relatorio.isSuccess){
        const file = new Blob(
          [relatorio.result],
          {type: 'application/pdf'});
        const fileURL = window.URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = fileURL;
        link.setAttribute('download', `visita_filiado.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setLoading(false);


      }
      else{
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack(relatorio.message);
        setShowMessageSnack(true);
      }
    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(MessageValues.erro_catch + ' Detalhamento erro: ' + e.toString());
      setShowMessageSnack(true);
    }
  }

  return (
    <ValidatorForm
      autoComplete="off"
    >
      <ProgressFullScreen
        open={loading}
        setOpen={setLoading}
      />
      <SnackbarCustom
        verticalOrientation='bottom'
        horizontalOrientation='center'
        open={showMessageSnack}
        setOpen={setShowMessageSnack}
        message={messageSnack}
        duration={2000}
        type={typeSnack}
      />

      <Dialog open={showDialogConfirmacaoDeleteVisitaFiliado} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Tem certeza que deseja remover essa visita?</DialogTitle>
        <DialogContent>
          <Alert
            severity="warning"
            variant="outlined"
          >
            <AlertTitle>Atenção</AlertTitle>
            A remoção de uma visita implica em uma série de responsabilidades para o usuário e para o filiado. Para
            garantir a integridade do sistema e do usuário, por favor digite sua senha de acesso ao sistema
            para confirmar essa ação

          </Alert>
          <Typography
            gutterBottom
            style={{marginTop: '30px'}}
          >
            {visitaFiliado.filiado &&
            'Nome do visitante: ' + visitaFiliado.filiado.nome
            }
          </Typography>
          <Typography
            gutterBottom
          >
            {visitaFiliado.filiado &&
            'CPF: ' + visitaFiliado.filiado.cpf
            }
          </Typography>
          <Typography
            gutterBottom

          >
            {
              'Data entrada: ' + moment(visitaFiliado.dataEntrada).format('DD/MM/YYYY HH:mm')
            }
          </Typography>
          <Typography
            gutterBottom
            style={{marginBottom: '30px'}}

          >
            {
              ( (visitaFiliado.dataSaida &&
                'Data saída: ' + moment(visitaFiliado.dataSaida).format('DD/MM/YYYY HH:mm'))
                || 'Data saída: Não informado')
            }
          </Typography>
          <TextField
            id="outlined-adornment-password"
            variant="outlined"
            margin="dense"
            fullWidth
            value={senha}
            type={mostrarSenha ? 'text' : 'password'}
            label="Informe a senha"
            onChange={e => setSenha(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    edge="end"
                    aria-label="toggle password visibility"
                    onClick={e => setMostrarSenha(!mostrarSenha)}
                  >
                    {mostrarSenha ? <VisibilityOff/> : <Visibility/>}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            helperText="Insira sua senha para confirmação de exclusão dessa visita."
            validators={['required']}
            errorMessages={['Senha']}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={e => onCancelDeleteVisitaFiliado()} color="primary">
            Cancel
          </Button>
          <Button onClick={e => deleteVisita(e)} color="primary">
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
      <div className={classes.root}>
        <Paper >

          <div>
            <Grid
              container
            >
              <Grid
                item
                md={12}
                xs={12}
              >
                <VisitaFiliadoVisualizacaoToolbar
                  className={classes.toolbar}
                  history={history}
                  deleteVisita={showConfirmationDeleteVisitaFiliado}
                  downloadPDF={downloadPDF}
                />

              </Grid>
              <Grid
                md={12}
                xs={12}
              >
                <VisitaFiliadoVisualizacaoDetalhes
                setShowMessageSnack={setShowMessageSnack}
                setMessageSnack={setMessageSnack}
                setTypeSnack={setTypeSnack}
                setLoading={setLoading}
                visitaFiliado={visitaFiliado}
                setVisitaFiliado={setVisitaFiliado}
                history={history}
                modalidades={modalidades}
                armas={armas}
                insumos={insumos}
                pacotes={pacotes}
              />
              </Grid>

            </Grid>
          </div>
        </Paper>

      </div>
    </ValidatorForm>
  );
}
